const TRANSITION_DURATION = 650;
const HIGHLIGHT_DURATION = 1800;
const BETWEEN_ITEMS_DURATION = 500;

export const initBenefitsAnimations = (): void => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll<HTMLElement>('[data-benefits-animation]').forEach((section) => {
    const items = Array.from(section.querySelectorAll<HTMLElement>('.benefits__item'));

    if (items.length < 2 || reducedMotion.matches) {
      return;
    }

    let previousIndex = -1;
    let remainingIndices: number[] = [];
    let highlightTimer: number | undefined;
    let nextItemTimer: number | undefined;
    let isVisible = false;

    const clearTimers = (): void => {
      window.clearTimeout(highlightTimer);
      window.clearTimeout(nextItemTimer);
    };

    const createRandomRound = (): number[] => {
      const indices = items.map((_, index) => index);
      const swap = (firstIndex: number, secondIndex: number): void => {
        const firstValue = indices[firstIndex];
        const secondValue = indices[secondIndex];

        if (firstValue === undefined || secondValue === undefined) {
          return;
        }

        indices[firstIndex] = secondValue;
        indices[secondIndex] = firstValue;
      };

      for (let index = indices.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        swap(index, randomIndex);
      }

      if (indices[0] === previousIndex && indices.length > 1) {
        swap(0, 1);
      }

      return indices;
    };

    const selectNextIndex = (): number | undefined => {
      if (remainingIndices.length === 0) {
        remainingIndices = createRandomRound();
      }

      return remainingIndices.shift();
    };

    const animateNextItem = (): void => {
      if (!isVisible) {
        return;
      }

      const nextIndex = selectNextIndex();

      if (nextIndex === undefined) {
        return;
      }

      const item = items[nextIndex];

      if (!item) {
        return;
      }

      previousIndex = nextIndex;
      item.classList.add('is-highlighted');

      highlightTimer = window.setTimeout(() => {
        item.classList.remove('is-highlighted');
        nextItemTimer = window.setTimeout(
          animateNextItem,
          TRANSITION_DURATION + BETWEEN_ITEMS_DURATION
        );
      }, TRANSITION_DURATION + HIGHLIGHT_DURATION);
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry) {
          return;
        }

        isVisible = entry.isIntersecting;
        clearTimers();

        if (isVisible) {
          nextItemTimer = window.setTimeout(animateNextItem, BETWEEN_ITEMS_DURATION);
        } else {
          items.forEach((item) => item.classList.remove('is-highlighted'));
        }
      },
      { threshold: 0.15 }
    );

    observer.observe(section);
  });
};
